// - fx/effects/interpolateEllipse.js
/**
 * interpolateEllipse — Clip-Path Ellipse Interpolator
 * ----------------------------------------------------
 * Convenience wrapper around interpolateCSSVars() for the
 * ellipse-based header effect.
 *
 * Why a wrapper?
 * --------------
 * - Keeps FX usage clean:
 *
 *     callback = interpolateEllipse({ reverse: true })
 *
 * - Provides a semantic function name for designers/devs
 * - Makes the mapping table reusable and maintainable in one place
 * - Allows future adjustments (additional vars, easing, breakpoints…)
 *
 * Options
 * -------
 *   reverse: boolean (default false)
 *     If true → animation direction is inverted (1 - t)
 *
 * Internally this simply forwards parameters to interpolateCSSVars(),
 * using the standard ellipse variable mapping:
 *
 *     --cx   ←  (--start-x,       --end-x)
 *     --cy   ←  (--start-y,       --end-y)
 *     --posY ←  (--start-pos-y,   --end-pos-y)
 *
 * Typical usage in FXEngine:
 *
 *   new FX({
 *     selector: "header .clipFx",
 *     limits: { ... },
 *     callback: interpolateEllipse({ reverse: true })
 *   });
 */
import { interpolateCSSVars } from "./interpolateCSSVars.js";

export function interpolateEllipse({ reverse = false } = {}) {

    return interpolateCSSVars({
        reverse,
        map: {
            "--cx":   ["--start-x", "--end-x"],
            "--cy":   ["--start-y", "--end-y"],
            "--posY": ["--start-pos-y", "--end-pos-y"]
        }
    });

}
